/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */
import request from "@/router/axios";
import qs from "qs";
import store from "@/store";
import { clearStorage } from '@/util/useful'

const scope = "server";

export const loginByUsername = (username, password, code, randomStr) => {
  let grant_type = "password";
  let dataObj = qs.stringify({ username: username, password: password });

  // Y3VzdG9tOmN1c3RvbQ==      cGlnOnBpZw==
  return request({
    url: "/auth/oauth/token",
    headers: {
      isToken: false,
      "TENANT-ID": "1",
      Authorization: "Basic cGlnOnBpZw==",
    },
    method: "post",
    params: { randomStr, code, grant_type },
    data: dataObj,
  });
};

export const refreshToken = (refresh_token) => {
  const grant_type = "refresh_token";
  return request({
    url: "/auth/oauth/token",
    headers: {
      isToken: false,
      "TENANT-ID": "1",
      Authorization: "Basic cGlnOnBpZw==",
    },
    method: "post",
    params: { refresh_token, grant_type, scope },
  });
};

export const loginByMobile = (mobile, code) => {
  const grant_type = "mobile";
  return request({
    url: "/auth/mobile/token/sms",
    headers: {
      isToken: false,
      "TENANT-ID": "1",
      Authorization: "Basic cGlnOnBpZw==",
    },
    method: "post",
    params: { mobile: "SMS@" + mobile, code: code, grant_type },
  });
};

export const loginBySocial = (state, code) => {
  const grant_type = "mobile";
  return request({
    url: "/auth/mobile/token/social",
    headers: {
      isToken: false,
      "TENANT-ID": "1",
      Authorization: "Basic cGlnOnBpZw==",
    },
    method: "post",
    params: { mobile: state + "@" + code, grant_type },
  });
};

export const getUserInfo = () => {
  return request({
    url: "/admin/user/info",
    method: "get",
  });
};

export const logout = () => {
  return request({
    url: "/auth/token/logout",
    method: "delete",
  });
};

/**
 * 校验令牌，若有效期小于半小时自动续期
 */
export const checkToken = ($store) => {
  const token = store.getters.access_token;

  request({
    url: "/auth/oauth/check_token",
    headers: {
      isToken: false,
      Authorization: "Basic cGlnOnBpZw==",
    },
    method: "get",
    params: { token },
  })
    .then((response) => {
      const expire = response && response.data && response.data.exp;
      if (expire) {
        const expiredPeriod = expire * 1000 - new Date().getTime();
        //小于半小时自动续约
        if (expiredPeriod <= 30 * 60 * 1000) {
          $store.dispatch("RefreshToken").catch(() => {
            clearInterval(this.refreshTime);
          });
        }
      } else { // token到期
        clearStorage()
      }
    })
    .catch((error) => {
      // 错误处理
      clearStorage()
      console.error(error);
    });
};
